import { api } from '../axios';
import type { DialogStatus, Dialog, DialogMessageRole, DialogMode } from '../../types/chat';
import type { PaginatedResponse } from '../../types/api';
import type { GenericAbortSignal } from 'axios';
import { widgetService } from '@ai/widget/src/api/services/widget.service';

class DialogService {
  private baseUrl = '/platform/api/v1/dialog';

  getById = async (dialogId: string, signal?: GenericAbortSignal) =>
    await api.get<Dialog>(`${widgetService.rootOrigin}${this.baseUrl}/${dialogId}`, {
      signal: signal,
    });

  getPaginatedData = async ({
    userId,
    expertId,
    isVoice,
    page,
    perPage,
    dateFrom,
    dateTo,
  }: {
    userId?: string;
    expertId?: string;
    isVoice?: boolean;
    page?: number;
    perPage?: number;
    dateFrom?: string;
    dateTo?: string;
  }) => {
    const params = {
      user_id: userId,
      expert_id: expertId,
      is_voice: isVoice,
      page: page,
      per_page: perPage,
      date_from: dateFrom,
      date_to: dateTo,
    };

    return await api.get<PaginatedResponse<Dialog>>(`${this.baseUrl}/list_paginated`, {
      params,
    });
  };

  getActiveDialogs = async () => await api.get<Dialog[]>(`${this.baseUrl}/active`);

  finishDialog = async (dialogId: string) => {
    try {
      console.log('Finish dialog: ', dialogId);
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const { data } = await api.post<object>(
        `${widgetService.rootOrigin}${this.baseUrl}/${dialogId}/finish?tz=${timezone}`,
      );
      console.log('Dialog finished: ', data);
    } catch (error) {
      console.error('Finish dialog error: ', error);
    }
  };

  checkIfFinalPhrase = async (dialogId: string) => {
    try {
      return await api.get<{ dialog_id: string; dialog_status: DialogStatus }>(
        `${widgetService.rootOrigin}${this.baseUrl}/${dialogId}/is_finished`,
      );
    } catch (error) {
      // не кидаем ошибку сообщения, если этот запрос упал в ошибку
      console.error(error);
    }
  };

  saveMessage = async (dialogId: string, text: string, role: DialogMessageRole) =>
    await api.post(`${widgetService.rootOrigin}${this.baseUrl}/${dialogId}/message`, {
      text: text,
      role: role,
    });

  // getDialogMode = async (dialogId: string) =>
  //   await api.get<{ mode: DialogMode }>(`${origin || ''}${this.baseUrl}/${dialogId}/mode`);

  setDialogMode = async (dialogId: string, mode: DialogMode) =>
    await api.put<{ mode: DialogMode }>(
      `${widgetService.rootOrigin}${this.baseUrl}/${dialogId}/mode`,
      {
        mode: mode,
      },
    );

  stopGeneration = async (dialogId: string) =>
    await api.post(`${widgetService.rootOrigin}${this.baseUrl}/${dialogId}/stop_generation`);

  clearOperatorRequested = async (dialogId: string) =>
    await api.delete(`${this.baseUrl}/${dialogId}/operator_requested`);
}

export const dialogService = new DialogService();
